var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-200 min-h-screen app_page"},[_c('app-navbar'),_c('app-breadcrumbs'),_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"px-3 sm:px-4 py-6 sm:py-8"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }